import React from "react"
export function FlexiflyIconMono(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g
        id="prefix__FF-Icon-Monochrome"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__FF">
          <path
            d="M4.414 1.613a18.77 18.77 0 0115.249-.004l3.115 1.384c1.19 9.61-2.395 16.612-10.751 21.007-3.667-2.04-6.42-4.484-8.257-7.335l7.995-4.606.951 6.328 1.145-.9.693-7.25 3.68-2.404c1.187-.853-.208-2.695-1.38-1.852L13.305 8.3 6.79 6.537l-1.13.922 4.854 2.663-7.46 5.327C1.15 11.884.57 7.732 1.312 2.993z"
            id="prefix__Combined-Shape"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}
